import { Box, Button, Checkbox, Grid, Typography } from "@material-ui/core";
import { IconButton, Modal, Popover, Radio } from "@mui/material";
import { Reorder } from "framer-motion";
import {
  ArrowsClockwise,
  ArrowsDownUp,
  ArrowsLeftRight,
  Chats,
  DotsSix,
  DotsThreeVertical,
  FilmStrip,
  PaintBrushHousehold,
  Plus,
  SortAscending,
  X,
} from "phosphor-react";
import { useEffect, useState } from "react";
import { fdelete, fpost } from "../../../API/callsAPI.js";
import commonStyles from "../../../Utils/commonStyles.js";
import CommentBox from "../../Utilities/Comments/CommentBox.jsx";
import CommentPlaceholder from "../../Utilities/Comments/CommentPlaceholder.jsx";
import SequencerChats from "./SequencerChats.jsx";
import PlayerView from "./PlayerView.styles.js";
import TaskListForSequencerMix from "./TaskListForSequencerMix.jsx";
import ConfirmationModal from "../../Utilities/ConfirmationModal/ConfirmationModal.component.jsx";

const SequencerMixTaskAndSequenceViewer = ({
  sequences,
  projectId,
  templateId,
  playlistId,
  setSnackValue,
  selectedVersion,
  currentTime,
  setScreenshot,
  screenshot,
  canvasModal,
  setCanvasModal,
  isVideoPlaying,
  resetAllBatches,
  phase,
  shotsLineUp,
  handleShotsLineUp,
  setIsAddShotToTimelineModalOpen,
  addBetweenShots,
  setAddBetweenShots,
}) => {
  const classes = PlayerView();
  const commonClasses = commonStyles();
  const [selectedTab, setSelectedTab] = useState("tasks");
  const [selectedPhase, setSelectedPhase] = useState(phase || "");
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  useEffect(() => {
    setSelectedPhase(phase);
    if (!templateId) setSelectedTab("sequences");
  }, [phase]);

  const handleSyncWithLatest = async () => {
    try {
      setSnackValue({
        isOpen: true,
        message: `Syncing with latest`,
        isError: false,
      });
      const data = {
        replace_existing: true,
      };
      if (selectedPhase !== "") {
        data.phase = selectedPhase;
      }
      const syncData = {
        url: `sequencers/timelines/${playlistId}/sync/`,
        data,
      };
      const res = await fpost(syncData);
      // handleResetAndRefresh();
      resetAllBatches();
      setSnackValue({
        isOpen: true,
        message: `Synced With Latest`,
        isError: false,
      });
      console.log(res);
    } catch (error) {
      console.log(error);
      setSnackValue({
        isOpen: true,
        message: `Error syncing with latest`,
        isError: true,
      });
    }
  };

  return (
    <Box className={classes.taskAndShotsRoot}>
      <Box
        style={{
          boxSizing: "border-box",
        }}
      >
        <Button
          onClick={() => setSelectedTab("sequences")}
          style={{
            width: "50%",
            backgroundColor: selectedTab === "sequences" ? "#1B1D28" : "transparent",
            borderRadius: "5px 5px 0 0",
          }}
          startIcon={<FilmStrip size={20} />}
        >
          Timeline
        </Button>
        <Button
          disabled={!selectedVersion?.shotVersion?.id}
          onClick={() => setSelectedTab("chats")}
          style={{
            width: "50%",
            backgroundColor: selectedTab === "chats" ? "#1B1D28" : "transparent",
            borderRadius: "5px 5px 0 0",
          }}
          startIcon={<Chats size={20} />}
        >
          Comments
        </Button>
      </Box>
      <Box style={{ display: "flex", flexDirection: "column", position: "relative", flex: 1 }}>
        <Box className={classes.taskAndShotsContainer}>
          {selectedTab === "sequences" ? (
            <TimeLineTab
              shotsLineUp={shotsLineUp}
              handleShotsLineUp={handleShotsLineUp}
              resetAllBatches={resetAllBatches}
              playlistId={playlistId}
              setIsAddShotToTimelineModalOpen={setIsAddShotToTimelineModalOpen}
              addBetweenShots={addBetweenShots}
              setAddBetweenShots={setAddBetweenShots}
            />
          ) : selectedTab === "chats" &&
            selectedVersion !== null &&
            !isVideoPlaying ? (
            <SequencerChats
              selectedVersion={selectedVersion}
              refreshCounter={refreshCounter}
            />
          ) : (
            <CommentPlaceholder />
          )}
        </Box>
        {selectedTab === "sequences" ? (
          <Box className={classes.syncAndCompareButtons}>
            <Button
              startIcon={<ArrowsClockwise size={18} />}
              className={classes.syncWithLatestButtons}
              // onClick={handleSyncWithLatest}
              onClick={() => setIsConfirmModalOpen(true)}
            >
              Sync With Latest
            </Button>
            <Button
              disabled
              startIcon={<ArrowsLeftRight size={18} />}
              className={classes.syncWithLatestButtons}
            >
              Compare
            </Button>
          </Box>
        ) : selectedVersion !== null && !isVideoPlaying ? (
          <div style={{ marginTop: "10px", height: "60px" }}>
            <CommentBox
              currentTime={currentTime}
              selectedVersion={selectedVersion}
              refreshCounter={refreshCounter}
              setRefreshCounter={setRefreshCounter}
              projectId={projectId}
              setScreenshot={setScreenshot}
              screenshot={screenshot}
              canvasModal={canvasModal}
              setCanvasModal={setCanvasModal}
            />
          </div>
        ) : (
          ""
        )}
      </Box>

      <Modal
        open={isConfirmModalOpen}
        onClose={() => setIsConfirmModalOpen(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ConfirmationModal
          modalTitle="Sync Confirmation"
          helperText="Are you sure you want to sync with the latest version? This action will replace your current timeline with the latest version and cannot be undone."
          confirmButtonText="Yes, Sync it"
          cancelButtonText="No, Cancel"
          handleCloseDeleteModal={() => setIsConfirmModalOpen(false)}
          handleAction={handleSyncWithLatest}
        />
      </Modal>
    </Box>
  );
};

const TimeLineTab = ({
  shotsLineUp,
  resetAllBatches,
  playlistId,
  setIsAddShotToTimelineModalOpen,
  addBetweenShots,
  setAddBetweenShots,
}) => {
  const classes = PlayerView();
  const [canRearrange, setCanRearrange] = useState(false);
  const [rearrangedShotsLineUp, setRearrangedShotsLineUp] = useState([]);
  const [OpenMenu, setOpenMenu] = useState(null);
  const [selectedShot, setSelectedShot] = useState(null);
  const [switcVersionModalOpen, setSwitchVersionModalOpen] = useState(false);
  const commonClasses = commonStyles();

  const handleClick = (event, shot) => {
    setOpenMenu(event.currentTarget);
    setSelectedShot(shot);
  };

  const handleClose = () => {
    setOpenMenu(null);
  };

  useEffect(() => {
    setRearrangedShotsLineUp(shotsLineUp);
  }, [shotsLineUp]);

  const handleSave = async () => {
    const rearrangeIds = rearrangedShotsLineUp.map((shot) => shot.id);
    try {
      const res = await fpost({
        url: `sequencers/timelines/${playlistId}/rearrange/`,
        data: {
          new_order: rearrangeIds,
        },
      });
      setCanRearrange(false);
      resetAllBatches();
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemoveShot = async (id) => {
    try {
      const res = await fdelete({
        url: `sequencers/shot-reprs/${id}/`,
      });
      if (res.status === 204) {
        handleClose();
        resetAllBatches();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box className={classes.rightContainer}>
      {canRearrange ? (
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button
            className={classes.button1}
            startIcon={<X size={18} />}
            onClick={() => setCanRearrange(false)}
          >
            Exit Rearrange
          </Button>
          <Button className={classes.button2} onClick={handleSave}>
            Save
          </Button>
        </Box>
      ) : (
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button
            className={classes.button1}
            startIcon={<Plus size={18} />}
            onClick={() => setIsAddShotToTimelineModalOpen(true)}
          >
            Add shots
          </Button>
          <Button
            className={classes.button2}
            startIcon={<ArrowsDownUp size={18} />}
            onClick={() => setCanRearrange(true)}
          >
            Arrange
          </Button>
        </Box>
      )}
      {!canRearrange ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "3px",
            paddingInlineStart: "0px",
            padding: "5px",
            paddingTop: "10px",
            borderTop: "1px solid #252A38",
            height: "300px",
          }}
        >
          {rearrangedShotsLineUp?.map((shot, index) => (
            <>
              <div
                key={shot.id}
                value={shot}
                className={classes.singleSequenceContainer}
              >
                <div
                  style={{
                    width: "10px",
                    height: "54px",
                    backgroundColor: "#463F88",
                    borderTopLeftRadius: "5px",
                    borderBottomLeftRadius: "5px",
                  }}
                />
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px",
                    width: "85%",
                  }}
                >
                  <img
                    src={`${shot?.shotVersion?.thumbnail}`}
                    alt="image"
                    border="0"
                    height="36px"
                    width="36px"
                    style={{
                      borderRadius: "5px",
                      border: "1px solid #6C65D94D",
                    }}
                  />
                  <Box>
                    <Typography className={classes.taskTemplateTitle}>
                      {shot?.shotVersion?.name}
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Radio
                        size="small"
                        sx={{
                          width: "20px",
                          height: "20px",
                          color: "#F9F9F9",
                          "& .MuiSvgIcon-root": {
                            fontSize: "16px",
                          },
                        }}
                      />
                      <Typography className={classes.taskTemplateTitle}>
                        None
                      </Typography>
                    </div>
                  </Box>
                </Box>

                <IconButton
                  sx={{
                    height: "32px",
                    width: "32px",
                    borderRadius: "5px",
                    "&:hover": {
                      bgcolor: "#EEEEEE14",
                    },
                  }}
                  onClick={(e) => handleClick(e, shot)}
                >
                  <DotsThreeVertical size={24} color="#F9F9F9" />
                </IconButton>
              </div>
              {index !== rearrangedShotsLineUp.length - 1 && (
                <Box
                  sx={{
                    height: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "&:hover": {
                      "& .add-shot-button": {
                        opacity: 1,
                      },
                    },
                  }}
                >
                  <Box
                    className="add-shot-button"
                    sx={{
                      bgcolor: "#6C65D9",
                      width: "100%",
                      height: "2px",
                      position: "relative",
                      opacity: 0,
                    }}
                  >
                    <IconButton
                      sx={{
                        bgcolor: "#6C65D9",
                        width: "48px",
                        height: "22px",
                        padding: "2px 16px",
                        borderRadius: "100px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "absolute",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        "&:hover": {
                          bgcolor: "rgba(108, 101, 217, 0.9)",
                        },
                      }}
                      onClick={() => {
                        setAddBetweenShots([
                          shot.id,
                          rearrangedShotsLineUp[index + 1].id,
                        ]);
                        setIsAddShotToTimelineModalOpen(true);
                      }}
                    >
                      <Plus size={14} color="#F9F9F9" />
                    </IconButton>
                  </Box>
                </Box>
              )}
            </>
          ))}
        </div>
      ) : (
        <Reorder.Group
          axis="y"
          layoutScroll
          values={rearrangedShotsLineUp}
          onReorder={(e) => setRearrangedShotsLineUp(e)}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "3px",
            paddingInlineStart: "0px",
            padding: "5px",
            paddingTop: "10px",
            borderTop: "1px solid #252A38",
            height: "300px",
          }}
        >
          {rearrangedShotsLineUp?.map((shot) => (
            <Reorder.Item
              key={shot.id}
              value={shot}
              className={classes.singleSequenceContainer}
            >
              <div
                style={{
                  width: "10px",
                  height: "54px",
                  backgroundColor: "#463F88",
                  borderTopLeftRadius: "5px",
                  borderBottomLeftRadius: "5px",
                }}
              />
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "8px",
                  width: "85%",
                }}
              >
                <img
                  src={`${shot?.shotVersion?.thumbnail}`}
                  alt="image"
                  border="0"
                  height="36px"
                  width="36px"
                  style={{
                    borderRadius: "5px",
                    border: "1px solid #6C65D94D",
                  }}
                />
                <Box>
                  <Typography className={classes.taskTemplateTitle}>
                    {shot?.shotVersion?.name}
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Radio
                      size="small"
                      sx={{
                        width: "20px",
                        height: "20px",
                        color: "#F9F9F9",
                        "& .MuiSvgIcon-root": {
                          fontSize: "16px",
                        },
                      }}
                    />
                    <Typography className={classes.taskTemplateTitle}>
                      None
                    </Typography>
                  </div>
                </Box>
              </Box>
              <IconButton>
                <DotsSix size={24} color="#F9F9F9" />
              </IconButton>
            </Reorder.Item>
          ))}
        </Reorder.Group>
      )}
      <Popover
        id={Boolean(OpenMenu) ? "simple-popover" : undefined}
        open={Boolean(OpenMenu)}
        anchorEl={OpenMenu}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: "7.5px",
              bgcolor: "#323540",
            },
          },
        }}
      >
        <div
          style={{
            backgroundColor: "#252A38",
            border: "1px solid #606479",
            borderRadius: "10px",
            boxShadow: "0px 19px 45px 0px #0000001F",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "5px",
            width: "180px",
          }}
        >
          <Button
            disabled
            startIcon={<ArrowsLeftRight size={18} />}
            onClick={() => setSwitchVersionModalOpen(true)}
          >
            Switch version
          </Button>
          <Button
            startIcon={<X size={18} />}
            onClick={() => handleRemoveShot(selectedShot.id)}
          >
            Remove Shot
          </Button>
        </div>
      </Popover>
      <Modal
        open={switcVersionModalOpen}
        onClose={() => setSwitchVersionModalOpen(false)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#1B1D28",
            borderRadius: "20px",
            boxShadow: "0px 19px 45px 0px #0000001F",
            padding: "18px",
            width: "1200px",
            height: "800px",
            position: "relative",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6">Switch version</Typography>
            <IconButton onClick={() => setSwitchVersionModalOpen(false)}>
              <X size={18} color="#F9F9F9" />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography>Selected Version</Typography>
            <div>
              <Button startIcon={<SortAscending size={18} />}>Sort</Button>

            </div>
          </Box>
          <Grid container spacing={2}>
            {shotsLineUp.map((sin) => (
              <Grid item sm={6} md={2} key={sin.id}>
                <Box
                  sx={{
                    padding: "10px",
                    backgroundColor: "#252A38",
                    borderRadius: "5px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={
                      sin?.thumbnail ??
                      "https://i.ibb.co.com/8n8Cp0tC/image.png"
                    }
                    alt=""
                    style={{
                      height: "100px",
                      width: "100%",
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <Checkbox
                      style={{
                        padding: "0px",
                        minWidth: "0px",
                      }}
                    />
                    <Typography
                      sx={{
                        color: "#B1B5C9",
                        fontSize: "14px !important",
                      }}
                    >
                      {sin?.shotVersion?.name}
                    </Typography>
                  </Box>
                  <Box className={commonClasses.flexBetween}>
                    <Typography
                      sx={{
                        color: "#B1B5C9",
                        fontSize: "14px !important",
                      }}
                    >
                      None
                    </Typography>
                    <Typography
                      sx={{
                        color: "#6C65D9",
                        fontSize: "14px !important",
                      }}
                    >
                      Something
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
          <Box
            sx={{
              position: "absolute",
              bottom: "10px",
              width: "100%",
              padding: "10px",
              backgroundColor: "#252A38",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography> 1 shot version selected</Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "14px",
              }}
            >
              <Button
                style={{
                  border: "1px solid #6C65D9",
                  padding: "4px 8px",
                  borderRadius: "5px",
                }}
                startIcon={<PaintBrushHousehold />}
              >
                Clear Selection
              </Button>
              <Button
                style={{
                  backgroundColor: "#6C65D9",
                  padding: "4px 8px",
                  borderRadius: "5px",
                }}
                startIcon={<ArrowsLeftRight size={18} />}
              >
                Switch Version
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default SequencerMixTaskAndSequenceViewer;

